/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Features_EyebrowInputs */

const en_home_features_eyebrow = /** @type {(inputs: Home_Features_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Features`)
};

/**
* | output |
* | --- |
* | "Features" |
*
* @param {Home_Features_EyebrowInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_features_eyebrow = /** @type {((inputs?: Home_Features_EyebrowInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Features_EyebrowInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_features_eyebrow(inputs)
});
export { home_features_eyebrow as "home.features.eyebrow" }